import React, { memo, SVGProps } from 'react'

export const DotsHorizontalSmall = memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M3.99998 13.3842C4.7648 13.3842 5.38419 12.7648 5.38419 12C5.38419 11.2352 4.7648 10.6158 3.99998 10.6158C3.23517 10.6158 2.61578 11.2352 2.61578 12C2.61578 12.7648 3.23517 13.3842 3.99998 13.3842Z"
      fill="currentColor"
    />
    <path
      d="M12 13.3842C12.7648 13.3842 13.3842 12.7648 13.3842 12C13.3842 11.2352 12.7648 10.6158 12 10.6158C11.2352 10.6158 10.6158 11.2352 10.6158 12C10.6158 12.7648 11.2352 13.3842 12 13.3842Z"
      fill="currentColor"
    />
    <path
      d="M20 13.3842C20.7648 13.3842 21.3842 12.7648 21.3842 12C21.3842 11.2352 20.7648 10.6158 20 10.6158C19.2352 10.6158 18.6158 11.2352 18.6158 12C18.6158 12.7648 19.2352 13.3842 20 13.3842Z"
      fill="currentColor"
    />
  </svg>
))
